/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Image_Export_Status_Exporting_ImageInputs */



/**
* | output |
* | --- |
* | "Exporting image {current} of {total}..." |
*
* @param {Image_Export_Status_Exporting_ImageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_exporting_image = /** @type {((inputs: Image_Export_Status_Exporting_ImageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Exporting_ImageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation de l'image ${i?.current} sur ${i?.total}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Exportiere Bild ${i?.current} von ${i?.total}...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione dell'immagine ${i?.current} di ${i?.total}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт изображения ${i?.current} изображения ${i?.total}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportando imagen ${i?.current} de ${i?.total}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在导出 ${i?.total} 的图像 ${i?.current}...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`画像 ${i?.current} / ${i?.total} をエクスポートしています...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.total} की छवि ${i?.current} निर्यात की जा रही है...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportando imagem ${i?.current} de ${i?.total}...`)
	return /** @type {LocalizedString} */ (`Exporting image ${i?.current} of ${i?.total}...`)
});